import type { ParagraphIssueGroup } from '../types';
import type { Event } from '@patsnap/tahiti-core';

/**
 * 段落修复服务接口
 */
export interface ParagraphFixService {
    /**
     * 生成修复内容
     * @param issueGroup 段落问题信息
     * @param content 原始内容
     * @returns Promise<boolean> 生成是否成功
     */
    generateFixContent(content: string, issueGroup: ParagraphIssueGroup): Promise<boolean>;

    /**
     * 内容生成状态变化事件
     */
    readonly onContentGenerating: Event<{ issueGroup: ParagraphIssueGroup; isGenerating: boolean }>;

    /**
     * 内容生成开始事件
     */
    readonly onContentGenerateStart: Event<{ issueGroup: ParagraphIssueGroup }>;

    /**
     * 新内容生成事件
     */
    readonly onContentGenerate: Event<{ issueGroup: ParagraphIssueGroup; content: string }>;

    /**
     * 内容生成完成事件
     */
    readonly onGenerationComplete: Event<{ issueGroup: ParagraphIssueGroup; success: boolean; finalContent?: string }>;
}

export const ParagraphFixService = Symbol.for('ParagraphFixService');
